
<template>
  <div>
     <modal 
       name="assignVerifierModal" 
       classes="v-modal-sec"
       :min-width="200"
       :min-height="400"
       :scrollable="true"
       :reset="true"
       width="800px"
       height="auto">
       <div class="v-modal">
         <div class="popup-header fromDetailsPage">
           <h2 class="popup-title">{{isReAssignedToMe?'Verify I-9':'Assign Verifier'}}</h2>
           <span @click="$modal.hide('assignVerifierModal');closeAssignVerifierPopUp()">
             <em class="material-icons">close</em>
           </span>
         </div>
         <form @submit.prevent data-vv-scope="requestForm" @click="requestErr= ''">
          <div class="form-container">
                 <div class="custom-radio_wrap wf_radio"  >
                   <h5 class="subheading">How would you like to verify Form I-9?</h5>
                   <ul class="custom-radio mt-0 ml-0" >
                     <li> 
                       <vs-radio :disabled="isDisabled"  vs-name="selectProcess" @input="setVerificationProcess(false)" :vs-value="false" v-model="selectedVerification" class="w-full" >Physical Verification</vs-radio>
                     </li>
                     <li>
                       <vs-radio :disabled="isDisabled" vs-name="selectProcess" @input="setVerificationProcess(true)" :vs-value="true"  v-model="selectedVerification" class="w-full" >Remote Verification</vs-radio>
                     </li>
                   </ul>
                   <input  type="hidden" :name="'select_Process'" :key="'select_Process'" v-validate="'required'" data-vv-as="Field"  v-model="selectedVerification">
                   <span class="text-danger text-sm"   
                   v-show="errors.has('requestForm.select_Process')">{{ errors.first('requestForm.select_Process')}}</span>
                 </div>
                  
                
              
               <div class="vx-col  w-full" v-if="selectedOption== true">
                  <h5 v-if="isOptionVisible" class="subheading">Select who should verify and sign?</h5>
                 <ul class="custom-radio with_info mt-0 ml-0  pb-4" >
                   <li class="mb-2"> 
                     <vs-radio v-if="isOptionVisible" :disabled="isDisabled" vs-name="VerifyProcess" @input="setVerifyProcess(false)" :vs-value="false" v-model="selectedRepresentative" class="w-full" >Let Employee Choose Authorized Representative
                      <small class="info">This option allows you to permit an employee of your organization to choose the Authorized Representative</small>
                      </vs-radio>
                   </li>
                   <li>
                     <vs-radio :disabled="isDisabled"  vs-name="VerifyProcess" @input="setVerifyProcess(true)" :vs-value="true"  v-model="selectedRepresentative" class="w-full" >Employer Assigned Authorized Representative
                      <small  class="info">This option allows the employer to choose the Authorized Representative of your organization</small>
                     </vs-radio>
                     
                   </li>
                 </ul>
                 <input type="hidden" :name="'select_VerifyProcess'" :key="'select_VerifyProcess'" v-validate="'required'" data-vv-as="Field"  v-model="selectedRepresentative">
                 <span class="text-danger text-sm"  
                 v-show="errors.has('requestForm.select_VerifyProcess')">{{ errors.first('requestForm.select_VerifyProcess')}}</span>
               </div>
             <template v-if="selectedAuthRepresentative== true || selectedOption == false" >
              <h5 class="subheading" v-if="selectedOption == false && isOptionVisible">Select who should verify and sign?</h5>
                 <div class="vx-col  w-full">
                  <ul :class="{'pl-0': !selectedOption, 'custom-radio': true, 'v3': true, 'mt-0': true, 'ml-0': true}">
                   <li> 
                     <vs-radio :disabled="isDisabled" vs-name="EmployerRepresentative" @input="setEmployerRepresentative(false)" :vs-value="false" v-model="selectedEmployerRepresentative" class="w-full" >I will do it</vs-radio>
                         <!-- Schedule Video Verification Meeting container -->
                      <div class="schedule_video" v-if="selectedOption && selectedEmployerRepresentative === false && selectedRepresentative">
                        <template >
                          <h5 class="subheading">Schedule Video Verification Meeting</h5>
                          <div class="form-container p-0">
                            <div class="vx-row">
                              <datepickerField :disabled="isDisabled" :display="false" :wrapclass="'md:w-1/3'" :dateEnableFrom="featureDates"
                                :validationRequired="true" v-model="scheduleDate" :fieldName="'Date'" formscope="requestForm" label="Date" />
                              <selectField :disabled="isDisabled" :multiple="false" :display="true" :wrapclass="'md:w-1/3'" :formscope="'requestForm'"
                                :required="true" cid="category" :optionslist="timeList" v-model="scheduleTime" label="Time" fieldName="Time"
                                placeHolder="Select Time" />
                              <selectField :disabled="isDisabled" :multiple="false" class="w-full" :wrapclass="'md:w-1/3'" :display="true" :formscope="'requestForm'"
                                :required="true" cid="category" :optionslist="timeZoneList" v-model="scheduleTimezone" label="Timezone"
                                fieldName="Timezone" placeHolder="Select Timezone" />
                            </div>
                          </div>
                        </template>
                      </div>
                        <div class="form-container schedule_video"
                          v-if="(selectedOption && selectedEmployerRepresentative === false && selectedRepresentative)||(selectedOption == false && selectedEmployerRepresentative === false)">
                          <div class="form-group">
                            <label class="form_label">Comments<em></em></label>
                            <ckeditor data-vv-as="Comments" name="Description" v-validate="cmntRequired ? 'required':''" :editor="editor"
                              v-model="scheduleComment" :config="editorConfig"></ckeditor>
                            <span class="text-danger text-sm mt-2" v-show="errors.has('requestForm.Description')">{{
                              errors.first("requestForm.Description") }}</span>
                      
                            <!-- <ckeditor v-validate="cmntRequired ? 'required':''" v-model="scheduleComment"  :data-vv-as="'Description'"
                                                                        name="Description" class="w-full" :editor="editor" :config="editorConfig"></ckeditor>
                                                                        <span class="text-danger text-sm" v-show="errors.has('requestForm.Description')">{{ errors.first("requestForm.Description") }}</span> -->
                          </div>
                        </div>
                      
                    </li>
                      
                    

                   <li v-if="isOptionVisible" >
                     <vs-radio  vs-name="EmployerRepresentative" @input="setEmployerRepresentative(true)" :vs-value="true"  v-model="selectedEmployerRepresentative" class="w-full" >
                      Select Authorized Representative</vs-radio>
                      <div class="radio_slection_cnt asigned_verify" v-if="isSelectedAuthRepresentative">
                        <div class="con-select select-large">
                          <label class="form_label">Registered Verifiers<em>*</em> <span v-if="totalVerifiers > 0">{{ ` (${totalVerifiers})` }}</span></label>
                          <multiselect :disabled="isDisabled" v-model="selectedVerifier" :options="verifiersList" 
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true" :select-label="'Search Verifier'"
                            :placeholder="'Select Verifier'" label="name" track-by="name" :preselect-first="false"
                            :data-vv-as="'Registered Verifiers'" v-validate="'required'" :searchable="true"
                            @search-change="getVerifiersList" name="Registered Verifiers" 
                            :tag-placeholder="'Add New Verifier'" :taggable="false" 
                            :key="'Signatory1-Verifier'">
                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                          <span  class="text-danger text-sm mt-1" v-show="errors.has('requestForm.Registered Verifiers')">{{
                          errors.first("requestForm.Registered Verifiers") }}</span>
                            <!-- <selectField :vvas="'Registered Verifiers'"  :multiple="false"  :display="true" :wrapclass="'md:w-1/2'" :formscope="'requestForm'" :required="true"  cid="category"   :optionslist="verifiersList" v-model="selectedVerifier" label="Registered Verifiers"  fieldName="category" placeHolder="Select Verifier"   />  -->
                        </div>
                        <template v-if="selectedVerifier">
                        <div class="selected_list v2 v3" v-if="selectedVerifier">   
                            <div class="selected_item" >
                                <span class="dp">
                                    <avatar :size="34" :backgroundColor="'#0E1D48'" :initials="avtarName(selectedVerifier, 'name')"></avatar>
                                </span>
                                <div class="list_info">
                                    <div class="sign_title">
                                        <p>{{ checkProperty(selectedVerifier, 'name') }}</p>
                                        <span v-if="checkProperty(selectedVerifier, 'phone')&&checkProperty(selectedVerifier, 'phoneCountryCode','countryCallingCode')">{{ checkProperty(selectedVerifier, 'phoneCountryCode','countryCallingCode')+' '+checkProperty(selectedVerifier, 'phone') }}</span>
                                        <span class="email" v-if="checkProperty(selectedVerifier, 'email')">
                                          <img src="@/assets/images/closed_mail.png" />
                                          {{ checkProperty(selectedVerifier, 'email') }}
                                      </span>
                                    </div>
                                    
                                </div>
                                <a @click="selectedVerifier=null" class="close-icon">
                                    <XIcon size="16" />
                                </a>
                            </div>
                        </div>
                    </template>
                        <p class="createnew pt-2">Not found?
                            <span @click="addNewVerifier()">Add Verifier</span>
                        </p>
                      </div>
                   </li>
                 </ul>
                 <input type="hidden" :name="'select_EmployerRepresentative'" :key="'select_EmployerRepresentative'" v-validate="'required'" data-vv-as="Field"  v-model="selectedEmployerRepresentative">
                 <span class="text-danger text-sm" 
                 v-show="errors.has('requestForm.select_EmployerRepresentative')">{{ errors.first('requestForm.select_EmployerRepresentative')}}</span>
               </div>  
             </template>
           
          </div>
           <div class="popup-footer relative">
            <figure v-if="loadingRequest" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
            <vs-button v-if="selectedOption === false && selectedEmployerRepresentative === false" color="dark" :disabled="submitForm" @click="assignVerifier('Reject')" class="cancel" type="filled">Reject</vs-button>
            <vs-button v-if="selectedOption === false && selectedEmployerRepresentative === false" color="success" :disabled="submitForm" @click="assignVerifier()" class="save" type="filled">Approve</vs-button>
            <vs-button v-if="!(selectedOption === false && selectedEmployerRepresentative === false)" color="dark" @click="closeAssignVerifierPopUp()" class="cancel" type="filled">Cancel</vs-button>
            <vs-button v-if="!(selectedOption === false && selectedEmployerRepresentative === false)" color="success" :disabled="submitForm" @click="assignVerifier()" class="save" type="filled">{{selectedOption && selectedEmployerRepresentative === false && selectedRepresentative ?'Schedule':'Submit'}}</vs-button>
            <!-- <vs-button color="dark" @click="closeAssignVerifierPopUp()" class="cancel" type="filled">Cancel</vs-button> -->
            <!-- <vs-button color="success" :disabled="submitForm" @click="assignVerifier" class="save" type="filled">Submit</vs-button> -->
          </div>
         </form>
       </div>
     </modal>
     <inviteVerifier v-if="requestAddVerifier" @closeAddVerifierPopUp="closeAddVerifierPopUp" :caseDetails="caseDetails" />
   </div>
</template>

<script>
 import Datepicker from "vuejs-datepicker-inv";
import moment from "moment";
import Avatar from 'vue-avatar'
import { XIcon } from "vue-feather-icons";
import selectField from "@/views/forms/fields/simpleselect.vue";
import inviteVerifier from './inviteVerifier.vue'
import datepickerField from "@/views/forms/fields/datepicker.vue";
import Vue from 'vue';
Vue.use(CKEditor);
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
 components: {
  Datepicker,
  moment,
   Avatar,
   XIcon,
   selectField,
   inviteVerifier,
   datepickerField
  
 },
 provide() {
   return {
     parentValidator: this.$validator,
   };
 },
 data() {
   return {
    isOptionVisible:true,
    isDisabled:false,
    totalVerifiers:null,
    cmntRequired:false,
    featureDates: null,
    scheduleTime:'',
    timeList :this.generateScheduleTimes(),
    scheduleTimezone:'',
    timeZoneList: [],
    scheduleComment:'',
    editorConfig: {
      toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
    },
    editor: ClassicEditor,
    scheduleDate:'',
    verifiersList:[],
    verifierType:"",
     selectedVerifier:null,
     isSelectedAuthRepresentative:false,
     selectedAuthRepresentative:null,
     selectedEmployerRepresentative:null,
     selectedRepresentative:null,
     submitForm:false,
     check:false,
     selectedOption:null,
     formerrors: {
       msg: ""
     },
     selectedVerification:null,
     branchList:[],
     isSelectedBranch:null,
     branchError: '',
     requestAddVerifier:false,
     isRemotVerificationSelected:false,
     loadingRequest:false,
     requestErr:'',
   };
 },
 methods: {
  getVerifiersList(){
     let postData={
            "matcher": {
                "title": "",
                "statusList": [],
                "branchIds": [],
                "companyIds": [],
                "createdByIds": [],
                "createdDateRange": [],
                "roleIds": [
                    49
                ],
                "statusIds": [],
                "petitionTypeIds": [],
                "petitionSubTypeIds": [],
                "petitionCreatedDateRange": [],
                "petitionStatusIds": [],
                "getPetitionStats": false
            },
            "sorting": {
                "path": "createdOn",
                "order": 1
            },
            "page": 1,
            "perpage": 1000000,
            "getMasterData": true,
            "getBeneficiaryList": false,
            "branchId": "",
            "companyId": "",
            "timezone": "Asia/Calcutta",
            "today": "2024-06-25"
        };
        
        let path = '/users/list'
        this.$store.dispatch("commonAction", { "data": postData, "path": path }).then((response)=>{
          if(response.totalCount){
            this.totalVerifiers = response.totalCount
          }
          let tempList = _.forEach(response.list, (item)=>{
            item['id'] = item['_id'];
            return item
          })
          this.verifiersList = tempList
        })  

 },
   addNewVerifier(){
     this.requestAddVerifier=true
   },
   closeAddVerifierPopUp(data){
    this.getVerifiersList()
    this.selectedVerifier = data
     this.requestAddVerifier=false
   },
   setEmployerRepresentative(action){
     this.selectedEmployerRepresentative = action
     this.isSelectedAuthRepresentative = this.selectedEmployerRepresentative
   },
   setVerifyProcess(action){
    this.selectedEmployerRepresentative=null
     this.selectedRepresentative = action
     this.selectedAuthRepresentative = this.selectedRepresentative
     this.selectedVerifier = null;
     this.isSelectedAuthRepresentative = false;
   },
   setVerificationProcess(action) {
      if (this.selectedOption !== action) {
        this.selectedOption = action;
        if( this.selectedOption){
          this.verifierType = "remote"
        }else{
          this.verifierType = "physical"
        }
        this.selectedRepresentative = null;
        this.selectedEmployerRepresentative = null;
        this.selectedVerifier = null;
        this.isSelectedAuthRepresentative = false;
        this.selectedAuthRepresentative = null;
        this.scheduleComment=''
      }
    },
    generateScheduleTimes() {
    let scheduleTimes = [];
    let id = 1;

    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
            let formattedHour = hour.toString().padStart(2, '0');
            let formattedMinute = minute.toString().padStart(2, '0');
            scheduleTimes.push({
                id: id,
                name: `${formattedHour}:${formattedMinute}`
            });
            id++;
        }
    }

    return scheduleTimes;
},
 
   assignVerifier(action){
     this.$validator.validateAll('requestForm').then(result => {
      if(result){   
        if(action === 'Reject' && this.scheduleComment === ''){
        this.cmntRequired = true
        return;
        }
        let postData = {
        "i9Id": this.checkProperty(this.caseDetails, '_id'),
        "verifierType": this.verifierType,
        }


        let userInfo = {
          '_id' : this.getUserData['userId'],
          'roleId':this.getUserData['roleId'],
          'name':this.getUserData['name'],
          'email':this.getUserData['email'],
          'profilePicture':this.getUserData['profilePicture'],
          'phone':this.getUserData['phone'],
          'phoneCountryCode':this.getUserData['phoneCountryCode'],
          'verifierId':this.getUserData['userId'],
          'address':this.getUserData['address'],
          'tempUser':false
        }

        if(this.verifierType == 'physical'){
          if(this.selectedEmployerRepresentative == false){
            postData['chooseVerifyAndSign'] = this.selectedEmployerRepresentative?false:true
            postData['verifierInfo'] = userInfo
            postData['verifierId'] = this.getUserData['userId']
            postData['_id'] = this.getUserData['userId']
            postData['verifierApprOrReject'] = action == 'Reject' ? false : true
            postData['scheduleComment'] = this.scheduleComment
          }
          if(this.selectedEmployerRepresentative == true){
            postData['chooseVerifyAndSign'] = this.selectedEmployerRepresentative?false:true
            postData['verifierInfo'] = this.selectedVerifier
            if(this.checkProperty(this.selectedVerifier, '_id')){
              postData['verifierId'] = this.selectedVerifier['_id']
            }
            
           
          }

        }

        if(this.verifierType == 'remote'){
          if(this.selectedRepresentative == false){
            postData['authroizedRepresent'] = this.selectedRepresentative?false:true
            // postData['verifierInfo'] = this.getUserData
            // postData['verifierId'] = this.getUserData['userId']
            // postData['_id'] = this.getUserData['userId']
            // postData['verifierInfo'] = this.getUserData
          }
          if(this.selectedRepresentative == true){
            postData['authroizedRepresent'] = this.selectedRepresentative?false:true
            if(this.selectedEmployerRepresentative == false){
              postData['chooseVerifyAndSign'] = this.selectedEmployerRepresentative?false:true
              postData['scheduleType'] = 'schedule'
              postData['scheduleDate'] = this.scheduleDate
              postData['scheduleTime'] = this.scheduleTime['name']
              postData['scheduleTimezone'] =  this.scheduleTimezone['tempName']
              postData['scheduleComment'] = this.scheduleComment
              postData['verifierInfo'] = userInfo
              postData['verifierId'] = this.getUserData['userId']
              postData['_id'] = this.getUserData['userId']

            }else{
              postData['chooseVerifyAndSign'] = this.selectedEmployerRepresentative?false:true
              postData['verifierInfo'] = this.selectedVerifier
              if(this.checkProperty(this.selectedVerifier, '_id')){
                postData['verifierId'] = this.selectedVerifier['_id']
              }
            }
          }
        }
        let path = '/i9/assign-verifier'
        this.requestErr = '';
        this.loadingRequest = true;
        this.isDisabled=true
        this.$store.dispatch('commonAction', ({'data':postData, 'path':path})).then((response)=>{
          this.showToster({message:response.message ,isError:false});
          this.loadingRequest = false;
          this.isDisabled=false
          setTimeout(()=>{
                this.closeAssignVerifierPopUp();
            },1000)
        }).catch((err)=>{
              this.showToster({message:err,isError:true });
              this.requestErr = err;
              this.loadingRequest = false;
          })

       }
     })
   },
 
   closeAssignVerifierPopUp(data){
                this.$emit('closeAssignVerifierPopUp', data)
                this.$modal.hide('assignVerifierModal');
                this.requestErr= '';
            },
getTimeZoneList() {

let postData = {

    page: 1,

    perpage: 1000,

    category: "timezone"

}

this.$store.dispatch("getMasterData", postData).then((res) => {

    _.forEach(res['list'], (item) => {

      item['tempName'] = item['name']
      item.name = item['name'] + ' (' + item.id + ')';

        this.timeZoneList.push(item);



    })

})

}
 },
 mounted() {
   this.$modal.show('assignVerifierModal')
   this.featureDates = new Date();
  //  this.generateScheduleTimes()
   this.getVerifiersList()
   this.getTimeZoneList()
   if(this.isReAssignedToMe){
    if(this.checkProperty(this.caseDetails, 'verifierType')=='physical'){
      this.isOptionVisible=false 
      this.selectedVerification=false
      this.selectedOption=false
      this.selectedEmployerRepresentative=false
      this.$modal.show('assignVerifierModal')
      // this.isDisabled=true
    }
    if(this.checkProperty(this.caseDetails, 'verifierType')=='remote'){
      this.isOptionVisible=false 
      this.selectedVerification=true
      this.selectedOption=true
      this.selectedAuthRepresentative=true
      this.selectedEmployerRepresentative=false
      this.selectedRepresentative=true
      this.$modal.show('assignVerifierModal')
      // this.isDisabled=true
    }
   this.verifierType = this.checkProperty(this.caseDetails, 'verifierType')
   }
 },
 props:{
  caseDetails:null,
  isReAssignedToMe:{
    type:Boolean,
    default:false
  }
 },
};
</script>